import React, { useEffect, useState } from "react";
import PrayerCard from "./PrayerCard";

const PrayerGrid = ({ colorSettings = {}, prayerData, nextEvent }) => {
  const {
    bodyBackgroundColor = "#096D6D",
    bodyTextColor = "#ffffff",
    bodyTimingColor = "#ffffff",
    highlightColor = "#D39B51",
  } = colorSettings;
  
  const [prayers, setPrayers] = useState([]);
  
  useEffect(() => {
    // 1. If no data object at all, clear and return
    if (!prayerData) {
      setPrayers([]);
      return;
    }

    // 2. INDEPENDENT CHECKS:
    // Safely try to get iqamah times, default to empty object if missing
    const iqamah = prayerData.iqamatimes ? prayerData.iqamatimes : {};
    
    // Safely try to get start (adhan) times, default to empty object if missing
    const adhan = (prayerData.startTimes && prayerData.startTimes.timings) 
                  ? prayerData.startTimes.timings 
                  : {};
    
    const structuredPrayers = [
      { name: "FAJR", adhan: adhan.fajr, iqamah: iqamah.fajr },
      { name: "DHUHR", adhan: adhan.dhuhr, iqamah: iqamah.dhuhr },
      { name: "ASR", adhan: adhan.asr, iqamah: iqamah.asr },
      { name: "MAGHRIB", adhan: adhan.maghrib, iqamah: iqamah.maghrib },
      { name: "ISHA", adhan: adhan.isha, iqamah: iqamah.isha },
    ];

    setPrayers(structuredPrayers);
  }, [prayerData]);

  return (
    <div
      className="flex flex-col sm:flex-row justify-between text-center"
    >
      {prayers.length === 0 ? (
        <p className="text-gray-200 text-center w-full">Loading prayer times...</p>
      ) : (
        prayers.map((prayer, idx) => (
          <PrayerCard
            key={idx}
            {...prayer}
            isNext={nextEvent?.type === "daily" && prayer.name === nextEvent.name}
            colorSettings={{
              bodyBackgroundColor,
              bodyTextColor,
              bodyTimingColor,
              highlightColor,
            }}
          />
        ))
      )}
    </div>
  );
};

export default PrayerGrid;